import { TwoFactorSmsConfirm } from "@/components/Portal/UserAccount/Security/TwoFactorSmsConfirm";
import { useResendForSmsPhonenumberChange } from "@/hooks/useResendSms";

export const TwoFactorConfirmNumberChange = () => (
  <div>
    <TwoFactorSmsConfirm useResendAction={useResendForSmsPhonenumberChange} />
  </div>
);
